import React from 'react';
import useGlobals from '../../../../../../Hooks/useGlobals';
import Input from '../../../../../Utility/FormElements/Input';

interface BasicInformationSectionProps {
    isNew: boolean;
    title: string;
    baseUrl?: string;
    onTitleChange: (value: string) => void;
    onBaseUrlChange: (value: string) => void;
    errors: Record<string, string>;
}

const BasicInformationSection: React.FC<BasicInformationSectionProps> = ({ isNew, title, baseUrl, onTitleChange, onBaseUrlChange, errors }) => {
    const { i18n } = useGlobals();

    return (
        <div>
            <div className="my-4">
                <h4>{i18n.translate({ id: 'form.basicInfo.title', sourceName: 'OpenAPI' })}</h4>
            </div>

            <div>
                <label className="flex flex-col gap-2 text-sm">
                    {i18n.translate({ id: 'form.title.label', sourceName: 'OpenAPI' })}
                    <Input
                        inputType="text"
                        value={title}
                        onChange={onTitleChange}
                        placeholder={i18n.translate({
                            id: 'form.title.placeholder',
                            sourceName: 'OpenAPI',
                        })}
                        className="w-full"
                    />
                </label>
                {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
            </div>
            {!isNew && <div>
                <label className="flex flex-col gap-2 text-sm mt-2">
                    {i18n.translate({ id: 'form.baseUrl.label', sourceName: 'OpenAPI' })}
                    <Input
                        inputType="text"
                        value={baseUrl ?? ''}
                        onChange={(value) => onBaseUrlChange(value)}
                        placeholder={'https://openapi.example.com/api'}
                        className="w-full"
                    />
                </label>
                {errors.baseUrl && <span className="text-red-500 text-xs mt-1">{errors.baseUrl}</span>}
            </div>}
        </div>
    );
};

export default BasicInformationSection;
